import Login from "@/Pages/Login";
import App from "../Pages/App";
import { SIDE_TABS } from "@/Routes/sidebar.utility";
import SuspenseRouteHandler from "@/components/SuspenseRouteHandler/SuspenseRouteHandler";
import BaseComponent from "@/components/Empties/BaseComponent";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import NotFound from "@/Pages/NotFound";
import { RouteObject, redirect } from "react-router-dom";
import { apiRequest } from "@repo/api-services/Axios";
import URLS from "@repo/api-services/URLS";

const baseRoutes: RouteObject[] = [
  {
    index: true,
    element: <BaseComponent />,
  },
  {
    path: "login",
    loader: async () => {
      try {
        await apiRequest.get(URLS.AUTH_USER);
        return redirect("/home");
      } catch (error) {
        return null;
      }
    },
    element: <Login />,
  },
  ...SIDE_TABS.map((tab): RouteObject => {
    const hasSubTabs = tab.subTabs && tab.subTabs.length > 0;
    return {
      path: `${stringUtility.removeSpaceAddChar(tab.name, "-")}${
        hasSubTabs ? "/:subTab/*" : "/*"
      }`,
      element: <SuspenseRouteHandler route={tab.name} />,
    };
  }),
  {
    path: "test-route",
    element: <App />,
  },
  { path: "*", element: <NotFound /> },
];

export default baseRoutes;
